module.exports = __webpack_public_path__ + "img/v4_configCoinList_h.28d6b259.png";